import React from "react";
import { Container, Typography } from "@mui/material";
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

/**
 * Yellow status message for images uploaded via "Proceed with this image" option
 * Shows when user proceeds despite validation warnings (non-fundus or wrong eye)
 */
const ImageUploadedStatus = () => {
  return (
    <Container sx={{
      display: "flex", 
      alignItems: "center", 
      background: "#FFF9E6", 
      borderRadius: "4px", 
      border: "1px solid #FFE082", 
      padding: "1px", 
      gap: "2px"
    }}>
        <div style={{
          background: "#FFF9E6", 
          borderRadius: "50%", 
          display: "flex", 
          justifyContent: "center", 
          alignContent: "center"
        }}>
            <CheckRoundedIcon sx={{fill: "#F57C00"}} fontSize="small"/>
        </div>
        <Typography fontSize="10px" fontWeight={400} sx={{ color: "#F57C00" }}>
            Image Uploaded
        </Typography>
    </Container>
  )
}

export default ImageUploadedStatus;

